// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"55bf4a95","263":"55bf4a95","534":"55bf4a95"}[chunkId] + ".chunk.css";
};